import IframeBridge from 'IframeBridge';
import { innerSearch } from 'api/Api';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { findImage } from 'utils/Utils';

const PendingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { paymentState, setPaymentState } = usePaymentState();
  const [tid, setTid] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  //InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      // 결과 처리
      payResult(data);
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  useEffect(() => {
    if (paymentState.tid !== null) {
      setTid(paymentState.tid);

      setIsSuccess(true);
    }
  }, [paymentState]);

  const handleClickInnerSearch = e => {
    e.preventDefault();
    setIsLoading(true);
    transactResult.mutate();
  };

  const handleAllClose = e => {
    e.preventDefault();

    const returnObject = {
      resultStatus: 'PENDING',
      resultCode: paymentState.resultCode,
      resultMessage: paymentState.resultMessage,
      tid: paymentState.tid,
      orderId: paymentState.orderId,
      mallReserved: paymentState.mallReserved,
      returnUrl: paymentState.returnUrl,
      schemeGroup: paymentState.schemeGroup,
      schemeCode: paymentState.schemeCode,
    };

    if (isMobile) {
      const url = new URL(paymentState.returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('resultStatus', 'PENDING');
      params.set(
        'resultCode',
        paymentState.resultCode ? paymentState.resultCode : '',
      );
      params.set(
        'resultMessage',
        paymentState.resultMessage ? paymentState.resultMessage : '',
      );
      params.set('tid', paymentState.tid);
      params.set('orderId', paymentState.orderId);
      params.set(
        'mallReserved',
        paymentState?.mallReserved ? paymentState.mallReserved : '',
      );
      params.set(
        'schemeGroup',
        paymentState?.schemeGroup ? paymentState.schemeGroup : '',
      );
      params.set(
        'schemeCode',
        paymentState?.schemeCode ? paymentState.schemeCode : '',
      );
      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  const payResult = data => {
    // Data Set
    const resultStatus = String(data.data.response.resultStatus).toLowerCase();

    const payType = String(data.data.display.payType).toLowerCase();

    // PaymentState Set
    setPaymentState(prevState => ({
      ...prevState,
      resultCode: data.data.response.resultCode,
      resultMessage: data.data.response.resultMessage,
      tid: data.data.response.tid,
      orderId: data.data.response.orderId,
      mallReserved: data.data.response.mallReserved,
      // returnUrl: data.data.returnUrl,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));
    // 결과에따른 Paging 처리
    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        payType === 'vbank' || payType === 'otc'
          ? navigate('/vbankPending')
          : navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        if (isSuccess) {
          setIsLoading(false);
          return;
        }
        setIsLoading(false);
      }, 3000);
    }
  }, [isLoading, isSuccess]);

  return (
    <>
      {isLoading && (
        <div className="white-loading-section">
          <div className="white-spin" />
        </div>
      )}
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('receive.png')} />
          </div>
          <div className="title">{t('payment_decline_uc')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t(`payment_processing_confirm`)}
          </div>
        </div>
      </div>
      <div className="c-section">
        <div className="box confirmBox">
          <button className="orange" onClick={handleClickInnerSearch}>
            {t('payment_confirm')}
          </button>
          <button className="gray" onClick={handleAllClose}>
            {t('payment_processing_close')}
          </button>
        </div>
      </div>
    </>
  );
};

export default PendingPage;
